export default {"src":"/_next/static/image/public/icons/check-line.b55e268d3735f03ee33ac2b1db5afb7d.svg","height":18,"width":18};